










import { Component, Vue } from 'vue-property-decorator';
import { StoryUser } from '../StoryUser'
import * as utils from '../utils';
import * as utils_auth from '../utils_auth';
import { globalUC } from '../UserCache'
import ModalWrapperComponent from '@/components/ModalWrapperComponent.vue';             // @ is an alias to /src


@Component({
  name: 'CircleRequests',
  components: { ModalWrapperComponent }
})
export default class CircleRequestsView extends Vue {
  // prop reactive member variables publically available to the html template

  // public reactive member variables available to the html template

  public get loading(): boolean { return this.$store.state.loading }
  public get isAuthenticated(): boolean { return this.$store.getters.isAuthenticated }
  public get user(): StoryUser { return this.$store.getters.userObject }
  public get userId(): string { return this.$store.getters.userId }

  // public functions available to the html template

  // private, non-reactive member variables

  // private functions not available directly to HTML template
  private async mounted() {
    if (this.$store.state.devmode) console.log(`${this.$options.name} mounted()`)

    // @ts-ignore: because segment analytics is loaded in head script
    window.analytics.page(this.$options.name)

    if (this.isAuthenticated) {
      const user: StoryUser = await globalUC.get(this.userId, true)
      utils_auth.saveAuthStuffToStoreAndLocalStorage(user, null)
    }

    // if user has invitations to accept, pop it up; but not if they haven't finished the tutorial
    if (this.user && this.user.getCircle().pendingIncomingFollowers.length > 0 && this.user.tutorialStepsDone.includes('finishingScreen')) (this.$refs.RespondToInvites as any).show(`${this.user.firstName}, You Have Invitations to Join Your Circle`, 'md', null)
  }

}

